import Modal from "react-bootstrap/Modal";
import { useState } from "react";

import FlagModalBody from "./flagModalBody";
import "./flagModal.css";

const FlagModal = (props) => {
  const { flagPage, positions = [], isUnflagging, onHide, ...modalProps } = props;
  const [saving, setSaving] = useState(false);

  return (
    <Modal
      {...modalProps}
      onHide={saving ? undefined : onHide}
      backdrop={saving ? "static" : true}
      keyboard={!saving}
      centered
      dialogClassName="flag-modal-dialog"
      aria-labelledby="flag-modal-title"
    >
      <FlagModalBody
        flagPage={flagPage}
        positions={positions}
        hideModal={onHide}
        isUnflagging={isUnflagging}
        onSavingChange={setSaving}
      />
    </Modal>
  );
};

export default FlagModal;
